export enum StepNames {
  APPLICATION_LOADED = "Application Loaded",
  SUMMARY = "Summary",
  MODEL = "Model",
  SEGMENT = "Segment",
  INTERIOR = "Interior",
}